import React from "react";
import s from "./AssignNumber.module.scss";
import { useForm, Controller, SubmitHandler } from "react-hook-form";
import clsx from "clsx";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { generateConfirmation } from "../../../../../../../../global components/DestructiveModal/DestruvtiveModal";
import {
  parseClientError,
  swrFetcher,
  swrMutationFetcher,
  SwrMutationFetcherArgType,
} from "../../../../../../../../libs/api/Endpoints";
import { UseAuthToken } from "../../../../../../../../libs/api/userSession";
import useSWR from "swr";
import useSWRMutation from "swr/mutation";
import { generatetoast } from "../../../../../../../../global components/Toast";
import { SuccessDataType } from "../../../../../../../../libs/api/types";
import { Button } from "antd";
import { PaginatedGetPendingRequestType } from "../../../../../../../../libs/Utils/Types/NumberManagement";
import { Oval } from "react-loader-spinner";
type InputType = {
  number: string;
  user: string;
};
type PropType = {
  closeDrawer: () => void;
  number: string;
  id?: string;
  mutate?: () => void;
  status?: string;
};
export function AssignNumber({
  closeDrawer,
  number,
  id,
  mutate,
  status,
}: PropType) {
  const token = UseAuthToken();
  const { data: userRequest, isLoading } = useSWR<
    { data: PaginatedGetPendingRequestType["data"][0] },
    any,
    any
  >(
    token ? [`api/admin/phone-numbers/requests/${id}`, token] : null,
    swrFetcher,
    {
      revalidateOnFocus: true, // Refetch when the window regains focus
      // Refetch every 10 seconds (10000 ms)
      shouldRetryOnError: false, // Disable retrying on errors
    },
  );
  const { trigger: assignNumber, isMutating: assigning } = useSWRMutation(
    `api/admin/phone-numbers/requests/${id}/assign`,
    swrMutationFetcher,
  );

  const {
    control,
    formState: { errors },
    watch,
    handleSubmit,
    reset,
    register,
  } = useForm<InputType>({
    defaultValues: {
      number: number,
    },
  });
  const onSubmit: SubmitHandler<InputType> = (data) => {
    handleNumberAssignment(data.number);
  };

  const handleNumberAssignment = async (number: string) => {
    try {
      const fetcheArg: SwrMutationFetcherArgType = {
        token,
        requestOption: {
          method: "POST",
          body: JSON.stringify({ phoneNumber: number }),
          headers: {
            "Content-Type": "application/json",
          },
        },
      };
      const result: SuccessDataType<any> = await assignNumber(fetcheArg);
      generatetoast("success", result.message);
      reset();
      mutate && mutate();
      closeDrawer();
    } catch (error) {
      const e = parseClientError(error);
      generatetoast("error", e.message);
    }
  };
  if (isLoading) {
    return (
      <div className={s.loadingWrapper}>
        <Oval />
      </div>
    );
  }
  return (
    <div className={s.wrapper}>
      <form className={s.form}>
        <div className={clsx(s.inputWrapper)}>
          <label htmlFor="phoneNo" className={clsx(s.inputLabel)}>
            Phone number
          </label>
          <Controller
            name="number"
            control={control}
            rules={{ required: "Please enter a phone number" }}
            render={({ field }) => (
              <PhoneInput
                {...field} // ensures that the value and onChange are linked
                // country={countryCode.toLowerCase()} // default country
                enableSearch={true} // Enable searching countries
                placeholder="Enter phone number"
                onChange={(value) => field.onChange(value)}
                value={field.value}
                disabled
                containerClass={s.phoneInputContainer} // Custom CSS for container
                dropdownClass={s.phoneInputDropdown} // Custom CSS for dropdown
                inputClass={clsx(
                  s.phoneInput,
                  { [s.inputError]: errors.number }, // Handle input error class
                  s.PhoneInput, // Additional styles for PhoneInput
                )} // Input field class
                buttonClass={s.flagDropdown} // Dropdown for flag and country code
              />
            )}
          />

          {errors.number && (
            <span className={clsx(s.errorMessage)}>
              {errors.number.message}
            </span>
          )}
        </div>
        <div className={s.inputWrapper}>
          <label htmlFor="user" className={s.inputLabel}>
            Assign to
          </label>
          <input
            value={
              userRequest?.data.user.firstName +
              " " +
              userRequest?.data.user.lastName
            }
            className={clsx(
              s.input,
              { [s.inputError]: errors.number }, // Handle input error class
              s.input,
            )}
            disabled={true}
            {...register("user")}
          />
          {errors.user && (
            <span className={clsx(s.errorMessage)}>{errors.user.message}</span>
          )}
        </div>
      </form>
      <div className={s.footer}>
        <Button
          loading={assigning}
          disabled={!watch("number")}
          className={s.assignBtn}
          onClick={() =>
            generateConfirmation(
              "Assign number",
              `You are about to assign this number ${watch(
                "number",
              )} to ${watch("user")}.`,

              handleSubmit(onSubmit),
              assigning,
              "assign",
            )
          }
        >
          {"Assign"}
        </Button>
      </div>
    </div>
  );
}
